import * as Styles from "../v2/header/styles";
import { THEMES, withTooltip} from "cdk-radial";
import { ERHeaderMenu } from "./ERHeaderMenu";
import ValidationDialog from './ValidationDialog';
import { useState } from "react";

export const generateTooltipProps = (
  iconName: string,
  displayName: string
) => ({
  id: `header-tooltip-${iconName}`,
  text: displayName,
  theme: THEMES.LIGHT,
  styles: { zIndex: 1002, display: window.innerWidth < 501 && "none" },
});


const CDKGlobalLogo = withTooltip(Styles.Logo, generateTooltipProps('CDK Global Logo','Go back to Homepage'));
  
export default function ERHeader({ toggleView , isHome, oktaProfileData ,setLogout,handleLogout}: 
    {toggleView:any,isHome:any, oktaProfileData: any, setLogout: any, handleLogout: any}) {

  const [isValidationDialogOpen, setIsValidationDialogOpen] = useState(false);

  const goHome = () => {
    if(!isHome){
      setIsValidationDialogOpen(true)
    }else{
      toggleView();
    }
  }

  const handleValidationProceed = () => {
    setIsValidationDialogOpen(false)
    toggleView();
  }

  const handleCancel = () => {
    setIsValidationDialogOpen(false)
  }

  return (
    <Styles.PageHeader>
      <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: '100%' }}>
          <div>
            <CDKGlobalLogo
                height="32"
                viewBox="0 0 300 74"
                width="116"
                data-testid="global-header-logo"
                onClick={goHome}
                data-track-label
                onTouchStart={goHome}
              />
          </div>


          <div style={{ marginLeft: 'auto' }}>
        
          <div style={{display:'flex', flexDirection:'row', alignItems:'center',}}>
            <div style={{color:'white',marginRight:'20px'}}>{oktaProfileData?.profile?.firstName}&nbsp;{oktaProfileData?.profile?.lastName}</div>

              <ERHeaderMenu setLogout={setLogout} ></ERHeaderMenu>

            </div>
          </div>
       <ValidationDialog
              isOpen={isValidationDialogOpen}
              onValidationProceed={handleValidationProceed}
              onCancel={handleCancel}
            />
      </div>
    </Styles.PageHeader>
  );
}
